import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ChefHat, Plus } from "lucide-react";
import { api, isPublicView } from "@/lib/api";

export const EntityRecipes = ({ ent, canEdit }) => {
  const off = ent.category !== "Food" || isPublicView();
  const { data: recipes = [] } = useQuery({ queryKey: ["recipes", ent.universe_id, "food", ent.id], enabled: !off,
    queryFn: () => api.get(`/universes/${ent.universe_id}/recipes?entity_id=${ent.id}`).then((r) => r.data) });
  if (off || (!recipes.length && !canEdit)) return null;
  const base = `/u/${ent.universe_id}/recipes`;
  return (
    <section className="mt-8" data-testid="entity-recipes">
      <div className="mb-3 flex items-center justify-between">
        <div className="lf-label">Recipes{recipes.length ? ` · ${recipes.length}` : ""}</div>
        {canEdit && <Link to={`${base}/new?food=${ent.id}`} className="flex items-center gap-1 text-xs text-[#F59E0B] hover:underline" data-testid="entity-recipe-add"><Plus className="h-3.5 w-3.5" />Write a recipe</Link>}
      </div>
      {!recipes.length ? <p className="text-sm italic text-[#A8A090]">No recipe for this dish yet.</p> : (
        <ul className="space-y-1.5">{recipes.map((r) => (
          <li key={r.id}><Link to={`${base}/${r.id}`} className="inline-flex items-center gap-2 text-sm text-[#F3EBDD] hover:text-[#FBBF24]" data-testid={`entity-recipe-${r.id}`}><ChefHat className="h-3.5 w-3.5 text-[#F59E0B]" />{r.title}<span className="text-xs text-[#7A7468]">serves {r.servings}</span></Link></li>
        ))}</ul>
      )}
    </section>
  );
};
